/**
 * Better Auth's browser client.
 *
 * The API mounts Better Auth at `/api/auth/*` (its default `basePath`), and
 * requests go through the Vite dev proxy in `vite.config.ts`, so the browser
 * sees everything as same-origin — cookies set by the API attach to
 * `localhost:5173`, not to the API's own port. `baseURL` is therefore just the
 * page's own origin; the client appends `/api/auth` itself.
 *
 * This is deliberately separate from the accountless-participant flow in
 * `@bolao/shared` land: this client only ever talks to `/api/auth/*`, never to
 * `/api/participant/*`, mirroring the server-side split.
 */
import { createAuthClient } from 'better-auth/react';

export const authClient = createAuthClient({
  baseURL: window.location.origin,
});

export const { useSession, signIn, signOut } = authClient;
